module.exports = __webpack_public_path__ + "static/Bright@2x.30e768e5.png";